export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL ?? "";
export const MARKETING_URL: string =
  (import.meta.env.VITE_MARKETING_URL as string) || "https://daybrief.team";
